import AppEnvironments from './appEnvironments';

/* eslint-disable sort-keys */
if (!window.APP_CONFIG) {

	const { apiEndpoint } = AppEnvironments.dev;

	window.APP_CONFIG = {
		services: [
			{
				'@id': 'auditer',
				'@type': 'service',
				'@urn': '$:registry:service:auditer',
				'id': 'auditer',
				'name': 'Auditer',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'audit',
				},
			},
			{
				'@id': 'partition',
				'@type': 'service',
				'@urn': '$:registry:service:partition',
				'id': 'partition',
				'name': 'Partitions',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'partition',
				},
			},
			{
				'@id': 'rh',
				'@type': 'service',
				'@urn': '$:registry:service:rh',
				'id': 'rh',
				'name': 'RH',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'rh',
				},
			},
			{
				'@id': 'vehicle',
				'@type': 'service',
				'@urn': '$:registry:service:vehicle',
				'id': 'vehicle',
				'name': 'Véhicules',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'vehicle',
				},
			},
			{
				'@id': 'directory',
				'@type': 'service',
				'@urn': '$:registry:service:directory',
				'id': 'directory',
				'name': 'Directory',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'directory',
				},
			},
			{
				'@id': 'sales',
				'@type': 'service',
				'@urn': '$:registry:service:sales',
				'id': 'sales',
				'name': 'Sales',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'sales',
				},
			},
			{
				'@id': 'intervention',
				'@type': 'service',
				'@urn': '$:registry:service:intervention',
				'id': 'intervention',
				'name': 'Intervention',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'intervention',
				},
			},
			{
				'@id': 'invoice',
				'@type': 'service',
				'@urn': '$:registry:service:invoice',
				'id': 'invoice',
				'name': 'invoice',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'invoice',
				},
			},
			{
				'@id': 'mercure',
				'@type': 'service',
				'@urn': '$:registry:service:mercure',
				'id': 'mercure',
				'name': 'Mercure',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + '.well-known/mercure',
				},
			},
			{
				'@id': 'notification',
				'@type': 'service',
				'@urn': '$:registry:service:notification',
				'id': 'notification',
				'name': 'Notification',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'notification',
				},
			},
			{
				'@id': 'rights',
				'@type': 'service',
				'@urn': '$:registry:service:rights',
				'id': 'rights',
				'name': 'Rights',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'rights',
				},
			},
			{
				'@id': 'comment',
				'@type': 'service',
				'@urn': '$:registry:service:comment',
				'id': 'comment',
				'name': 'Comment',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'comment',
				},
			},
			{
				'@id': 'supplier',
				'@type': 'service',
				'@urn': '$:registry:service:supplier',
				'id': 'supplier',
				'name': 'Supplier',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'supplier',
				},
			},
			{
				'@id': 'file',
				'@type': 'service',
				'@urn': '$:registry:service:file',
				'id': 'file',
				'name': 'File',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'file',
				},
			},
			{
				'@id': 'suggestion',
				'@type': 'service',
				'@urn': '$:registry:service:suggestion',
				'id': 'suggestion',
				'name': 'Suggestion',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'suggestion',
				},
			},
			{
				'@id': 'analytics',
				'@type': 'service',
				'@urn': '$:registry:service:analytics',
				'id': 'analytics',
				'name': 'Analytics',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'analytics',
				},
			},
		],
	};
}

const AppConfig = window.APP_CONFIG;

export default AppConfig;